import { apiFetch } from './api'

export type SmartstoreTo =
  | 'studio'
  | 'invitations'
  | 'templates'
  | 'template'
  | 'create'
  | 'thankyou'
  | 'thankyou-create'
  | 'thankyou-design'

interface SmartstoreLinkResponse {
  url: string
  state: string
  expiresAt: string
}

export async function fetchSmartstoreLink(
  to: SmartstoreTo,
  id?: string,
): Promise<SmartstoreLinkResponse> {
  const params = new URLSearchParams({ to })
  if (id) params.set('id', id)
  return apiFetch<SmartstoreLinkResponse>(`/api/admin/smartstore-link?${params.toString()}`)
}

export async function copySmartstoreLinkToClipboard(to: SmartstoreTo, id?: string): Promise<string> {
  const res = await fetchSmartstoreLink(to, id)
  await navigator.clipboard.writeText(res.url)
  return res.url
}
